import { Injectable, signal } from '@angular/core';

/**
 * مدیریت حالت‌های UI سراسری که بین کامپوننت‌ها اشتراک‌گذاری می‌شوند.
 * مثلاً: مخفی کردن bottom-nav در حین splash/loading screen.
 */
@Injectable({ providedIn: 'root' })
export class AppUiStateService {
  /** آیا bottom-nav مخفی باشد (در حین splash/loading) */
  readonly hideBottomNav = signal(false);

  /** نمایش bottom-nav */
  showBottomNav(): void {
    this.hideBottomNav.set(false);
  }

  /** مخفی کردن bottom-nav */
  hideBottomNavFn(): void {
    this.hideBottomNav.set(true);
  }
}